import jwtDecode from 'jwt-decode'

import { userTypes as userTypesConstant } from 'constants/user'
import Cookie from 'helpers/cookie'
import { logger } from 'utils/logger'

export const userTypes = userTypesConstant // fallback for import in multiple files

export const getUserRoles = accessToken => {
    if (accessToken) {
        const { realm_access } = jwtDecode(accessToken)

        const { roles } = realm_access
        return roles
    }
}

export const getUserTypeFromToken = accessToken => {
    if (accessToken) {
        const roles = getUserRoles(accessToken)

        if (roles.includes('teacher')) {
            return userTypes.TEACHER
        } else {
            return userTypes.STUDENT
        }
    }

    return userTypes.NONE
}

export const getCookie = key => {
    return Cookie.get(key)
}

export const decodeJWT = token => {
    try {
        return jwtDecode(token)
    } catch (error) {
        console.log('invalid input :- ', error)
    }
}

export const isExpired = expDate => {
    if (!expDate) return true
    return Date.now() >= expDate * 1000
}

export const isTokenExpired = accessToken => {
    try {
        const decodedToken = decodeJWT(accessToken)
        if (decodedToken) {
            return isExpired(decodedToken?.exp)
        }
    } catch (error) {
        console.log('invalid input :- ', error)
    }
}

const FULL_NAME_REGEX = /^[a-zA-Z]{1,40}(?: +[a-zA-Z]{1,40})+$/

export const validateFullName = ({ firstName, lastName }) =>
    FULL_NAME_REGEX.test(`${firstName} ${lastName}`)

export const isCorrectAuthTokenIssuer = (token, environment) => {
    try {
        let issuerBaseUrl = 'https://auth.openhouse.study/'

        if (environment === 'DEMO') {
            issuerBaseUrl = 'https://demo.auth.openhouse.study/'
        }

        // extract token and get
        const { iss } = jwtDecode(token)

        return iss && iss.startsWith(issuerBaseUrl)
    } catch (error) {
        logger.error('error in checking correct auth token issuer :- ', error)
    }
}
